var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCautionWarn = function SvgCautionWarn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.126862 19L11.1269 0L22.1269 19H0.126862ZM11.1269 16C11.4102 16 11.6479 15.904 11.8399 15.712C12.0319 15.52 12.1275 15.2827 12.1269 15C12.1269 14.7167 12.0309 14.479 11.8389 14.287C11.6469 14.095 11.4095 13.9993 11.1269 14C10.8435 14 10.6059 14.096 10.4139 14.288C10.2219 14.48 10.1262 14.7173 10.1269 15C10.1269 15.2833 10.2229 15.521 10.4149 15.713C10.6069 15.905 10.8442 16.0007 11.1269 16ZM10.1269 13H12.1269V8H10.1269V13Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCautionWarn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cautionWarn.a9477b93.svg";
export { ForwardRef as ReactComponent };